import { useState } from "react";
import {
  ResponsiveContainer, BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
} from "recharts";

const GREEN = "#2F524A";
const GOLD = "#C9A227";
const axis = { fontSize: 11, fill: "#5C6661" };

const VIEWS = [
  { id: "monthly", label: "New each month" },
  { id: "total", label: "Running total" },
];

export const ImpactTrendChart = ({ trend }) => {
  const [view, setView] = useState("monthly");
  const data = trend.map((p) => ({ ...p, short: p.label.slice(0, 3) }));
  const common = (
    <>
      <CartesianGrid stroke="#E8ECEA" vertical={false} />
      <XAxis dataKey="short" tick={axis} axisLine={{ stroke: "#E8ECEA" }} tickLine={false} />
      <YAxis allowDecimals={false} tick={axis} axisLine={false} tickLine={false} width={32} />
      <Tooltip labelFormatter={(_, p) => p?.[0]?.payload?.label} />
      <Legend wrapperStyle={{ fontSize: 12 }} formatter={(v) => <span style={{ color: "#1C201F" }}>{v}</span>} />
    </>
  );

  return (
    <div className="mt-6" data-testid="impact-trend">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="eyebrow">Last 12 months</p>
        <div className="inline-flex rounded-full border border-[#E8ECEA] p-1">
          {VIEWS.map((v) => (
            <button key={v.id} onClick={() => setView(v.id)} data-testid={`impact-trend-${v.id}`}
              className={`text-xs px-3 py-1.5 rounded-full transition-colors ${
                view === v.id ? "bg-[#2F524A] text-white" : "text-[#1C201F] hover:bg-[#F4F7F6]"}`}>
              {v.label}
            </button>
          ))}
        </div>
      </div>
      <div className="h-64 mt-3" data-testid={`impact-trend-chart-${view}`}>
        <ResponsiveContainer width="100%" height="100%">
          {view === "monthly" ? (
            <BarChart data={data} barGap={2}>
              {common}
              <Bar dataKey="new_homes" name="Homes tested" fill={GREEN} radius={[3, 3, 0, 0]} />
              <Bar dataKey="new_systems" name="Systems installed" fill={GOLD} radius={[3, 3, 0, 0]} />
            </BarChart>
          ) : (
            <LineChart data={data}>
              {common}
              <Line dataKey="total_homes" name="Homes tested" stroke={GREEN} strokeWidth={2} dot={false} />
              <Line dataKey="total_systems" name="Systems installed" stroke={GOLD} strokeWidth={2} dot={false} />
            </LineChart>
          )}
        </ResponsiveContainer>
      </div>
    </div>
  );
};
